var map = {
	"./Shape.png": "8a53",
	"./Shape.svg": "37b9",
	"./ZaffaJiraffa.jpg": "4df0",
	"./android.png": "0e70",
	"./arrow_left.svg": "ef6a",
	"./arrow_left_white.png": "10be",
	"./arrow_left_white.svg": "f9df",
	"./bounds.png": "ac83",
	"./carrito.png": "b028",
	"./carrito.svg": "78d1",
	"./close.svg": "2930",
	"./commerce_internal/arrow_left_white.svg": "4042",
	"./commerce_internal/asesoria.svg": "250d",
	"./commerce_internal/bar.svg": "9237",
	"./commerce_internal/boton-hor-1.png": "35e9",
	"./commerce_internal/boton-hor-c.png": "d8bd",
	"./commerce_internal/boton-hor-c1.png": "c874",
	"./commerce_internal/boton-hor-c2.png": "d851",
	"./commerce_internal/boton-ver-1.png": "85ec",
	"./commerce_internal/boton-ver-2.png": "d698",
	"./commerce_internal/boton-ver-3.png": "6eab",
	"./commerce_internal/circulo.svg": "c4bb",
	"./commerce_internal/close.png": "7290",
	"./commerce_internal/close.svg": "e588",
	"./commerce_internal/comencemos.png": "5dfe",
	"./commerce_internal/content-while.png": "2263",
	"./commerce_internal/content-while.svg": "25c3",
	"./commerce_internal/content-yellow.png": "d3f7",
	"./commerce_internal/content-yellow.svg": "8ddd",
	"./commerce_internal/content-yellow2.png": "82ae",
	"./commerce_internal/content-yellow2.svg": "2822",
	"./commerce_internal/contrasena.svg": "fce1",
	"./commerce_internal/dispositivos.svg": "8bb5",
	"./commerce_internal/dispositivos2.png": "45dd",
	"./commerce_internal/dispositivos3.png": "6c84",
	"./commerce_internal/food.png": "778f",
	"./commerce_internal/food.svg": "77b8",
	"./commerce_internal/img1.png": "a244",
	"./commerce_internal/img2.png": "c1bf",
	"./commerce_internal/img22.png": "4320",
	"./commerce_internal/img3.png": "b533",
	"./commerce_internal/img33.png": "9067",
	"./commerce_internal/instrumentos.svg": "cdab",
	"./commerce_internal/nube.svg": "4846",
	"./commerce_internal/nube2.png": "d994",
	"./commerce_internal/nube3.svg": "a587",
	"./commerce_internal/nuevo-producto.svg": "c6fe",
	"./commerce_internal/program.png": "6654",
	"./commerce_internal/program_2.png": "84f6",
	"./commerce_internal/rectangle-2.png": "ac76",
	"./commerce_internal/rectangle.png": "aac4",
	"./commerce_internal/taza.gif": "0d2a",
	"./dummy-presentation.png": "c502",
	"./facebook.png": "5b2d",
	"./finance.svg": "10bd",
	"./gift.svg": "754a",
	"./home-imagen.png": "42bb",
	"./home-imagen2.png": "4477",
	"./home-imagen3.png": "0174",
	"./home-movil.png": "4f6f",
	"./id.svg": "c3cf",
	"./ingresos.png": "f002",
	"./ingresos.svg": "86b7",
	"./instagram.png": "cda7",
	"./iphone.png": "eea5",
	"./link.svg": "b434",
	"./linkedin.png": "beb0",
	"./linkeding.png": "babf",
	"./logo-footer.svg": "86c5",
	"./market.svg": "00cf",
	"./polygon-r.svg": "f436",
	"./rectangulo-gray.svg": "2e53",
	"./rectangulo-l.svg": "72ae",
	"./rectangulo-r.svg": "61ae",
	"./rectangulo.png": "81f1",
	"./section-solution-2.png": "1400",
	"./section-solution.png": "5551",
	"./shop.svg": "7455",
	"./socio0.png": "2c51",
	"./socio1.png": "f06f",
	"./socio11.png": "83de",
	"./socio12.png": "e8b2",
	"./socio13.png": "3993",
	"./socio14.png": "fac6",
	"./socio15.png": "0027",
	"./socio2.png": "2de2",
	"./socio3.png": "6464",
	"./socio4.png": "8a5d",
	"./socio5.png": "004f",
	"./socio6.png": "ffa6",
	"./socio7.png": "e716",
	"./socio8.png": "960f",
	"./socio9.png": "5436",
	"./statistic.svg": "eead",
	"./store-apple.png": "76ff",
	"./store-play.png": "20f6",
	"./terms-img.png": "5ad3",
	"./user_internal/caja.svg": "16d0",
	"./user_internal/caja2.png": "f343",
	"./user_internal/content.png": "fc77",
	"./user_internal/content_all.svg": "6e4f",
	"./user_internal/content_all2.png": "6e34c",
	"./user_internal/content_all3.png": "58d9",
	"./user_internal/google.png": "6ae6",
	"./user_internal/rectangle.png": "758f",
	"./user_internal/rectangle_2.png": "21a9",
	"./user_internal/rectangle_all.png": "b86d",
	"./user_internal/store.png": "a51c",
	"./user_internal/sum.png": "c6ce",
	"./user_internal/tlf_acum.png": "68bf",
	"./user_internal/tlf_dep.png": "a3bc",
	"./user_internal/tlf_dep.svg": "21aa",
	"./user_internal/tlf_dep2.png": "049d",
	"./user_internal/tlf_dep3.png": "7b7d",
	"./user_internal/tlf_sum.png": "cdf0",
	"./user_internal/tlf_sum2.png": "a238",
	"./user_internal/tlf_sum4.png": "0818",
	"./user_internal/tlf_sum5.png": "8868",
	"./user_internal/vineta.png": "2a01",
	"./usuarios.png": "d008",
	"./usuarios.svg": "7160",
	"./we/back_name.png": "4bd3",
	"./we/circulo.svg": "d799",
	"./we/fondo.png": "8333",
	"./we/gox.png": "83f1",
	"./we/gox2.png": "ed23",
	"./we/gox3.png": "0d20",
	"./we/program.png": "d866",
	"./we/team.png": "cae9",
	"./we/team/team_1.png": "4dc8",
	"./we/team/team_2.png": "85a6",
	"./we/team/team_3.png": "27fa",
	"./we/team2.png": "3135",
	"./youtube.png": "3d43"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";